module.exports = __webpack_public_path__ + "static/media/diamond-card-back.eb2fa188.png";